import React, { useState, useEffect } from "react";
import AnalysisResult from "./AnalysisResult";
import { AiOutlineClose } from "react-icons/ai";

const ConsoleAnalysis = ({
  comments,
  error,
  analysisResult,
  messageIDs,
  exportAnalysisData,
}) => {
  const [index, setIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const analysisOrder = [
    "Coherence",
    "Orientation",
    "Nuance",
    "Support",
    "Ongoing",
    "Leadership",
    "Empathy",
  ];

  const map = {
    Coherence: "C",
    Orientation: "O",
    Nuance: "N",
    Support: "S",
    Ongoing: "O",
    Leadership: "L",
    Empathy: "E",
  };

  const handleIDButtonClick = (index) => {
    setIndex(index);
    setIsModalOpen(true);
  };

  const mapConsoleLabels = () => {
    return analysisOrder.map((key) => map[key]);
  };

  const mapConsoleValues = (numericValues) => {
    return analysisOrder.map((key) => numericValues[key]);
  };

  const isOrange = (value) => {
    return value === 1 ? "orange" : "text-gray-300";
  };

  const isOrangeBG = (value) => {
    return value === 1 ? "bg-light-orange" : "bg-white";
  };

  return (
    <div>
      {error && (
        <div
          className={`font-bold error-message mx-96 rounded-b-lg ${
            error.includes("Analysing...") ? "generating" : "active"
          }`}
        >
          {error.toLowerCase().includes("try") ? (
            <span
              className="underline cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                window.location.reload();
              }}
            >
              {error}
            </span>
          ) : (
            error
          )}
        </div>
      )}
      {analysisResult && (
        <div className="mt-8 analysis-result">
          <div className="flex justify-between items-center">
            <p
              style={{ fontFamily: "Red Hat Display" }}
              className="mb-2 text-xl font-bold orange"
            >
              CONSOLE Analysis
            </p>

            {/* Export CSV */}
            <div className="flex justify-end mb-4">
              <button
                className="px-4 py-2 text-white bg-orange-500 rounded duration-200 hover:bg-orange-600"
                onClick={exportAnalysisData}
              >
                Export Analysis Data
              </button>
            </div>
          </div>

          {/* Column */}
          <div className="flex justify-between gap-1">
            <div className="flex justify-center w-1/6 px-4 py-6 rounded-lg shadow-sm bg-light-orange">
              <p className="content-center font-bold text-center text-wrap orange lg:text-xl md:text-xl sm:text-xl">
                Comment ID
              </p>
            </div>

            <div className="grid w-3/4 grid-cols-7 gap-1 border-2 border-gray-100 rounded-lg shadow-sm">
              {mapConsoleLabels().map((label, index) => (
                <div
                  key={index}
                  className="flex items-center justify-center h-full orange bg-light-orange"
                >
                  <p className="text-4xl font-bold md:text-xl sm:text-xl orange">
                    {label}
                  </p>
                </div>
              ))}
            </div>
            <div className="flex justify-center w-1/6 px-4 py-6 rounded-lg shadow-sm bg-light-orange">
              <p className="font-bold text-center text-wrap orange lg:text-xl md:text-xl sm:text-xl">
                Aggregate Score
              </p>
            </div>
          </div>

          {/* Score */}
          {analysisResult.map((resultArray, index) => (
            <div key={index} className="gap-12 mt-4">
              <div className="flex justify-between gap-1">
                <button
                  className="flex w-1/6 justify-center px-4 py-6 rounded-lg shadow-sm bg-light-orange hover:bg-[#ffe6dd] duration-200"
                  onClick={() => handleIDButtonClick(index)}
                >
                  <p className="content-center font-bold text-center break-all text-wrap orange lg:text-xl md:text-xl sm:text-xl">
                    {messageIDs[index]}
                  </p>
                </button>
                <div className="grid w-3/4 grid-cols-7 gap-1 border-2 border-gray-100 rounded-lg shadow-sm">
                  {mapConsoleLabels().map((label, labelIndex) => (
                    <div
                      key={labelIndex}
                      className={`flex items-center justify-center h-full ${isOrangeBG(
                        resultArray[0].numericValues[analysisOrder[labelIndex]]
                      )}`}
                    >
                      <p
                        className={`text-4xl md:text-xl sm:text-xl content-center ${isOrange(
                          resultArray[0].numericValues[
                            analysisOrder[labelIndex]
                          ]
                        )}`}
                      >
                        {
                          resultArray[0].numericValues[
                            analysisOrder[labelIndex]
                          ]
                        }
                      </p>
                    </div>
                  ))}
                </div>
                <div
                  className={`flex px-8 py-6 rounded-lg w-1/6 justify-center shadow-sm ${
                    resultArray[0].score < 0.5 ? "bg-[#ff4949]" : "bg-[#0ad114]"
                  } `}
                >
                  <div className="flex">
                    <p className="content-center font-bold text-white lg:text-4xl md:text-4xl sm:text-4xl">
                      {resultArray[0].score}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black bg-opacity-50">
          <div className="relative max-h-screen p-10 overflow-y-auto bg-white rounded-lg shadow-lg max-w-7xl">
            <div className="flex justify-end">
              <button onClick={() => setIsModalOpen(false)}>
                <AiOutlineClose size={24} />
              </button>
            </div>
            <p className="text-lg italic font-bold text-center">
              "{comments[index]}"
            </p>
            <AnalysisResult
              analysisResult={analysisResult[index]}
              analysisOrder={analysisOrder}
              mapConsoleLabels={mapConsoleLabels}
              mapConsoleValues={mapConsoleValues}
              isOrange={isOrange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsoleAnalysis;
